import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
  CardHeader,
  Typography,
  Divider,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { imgUrl, url } from "src/Helpers/utils/Constant";
import axios from "axios";
import Toaster from "src/Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useState } from "react";

const UpdateCompanyDocsInfo = ({ id, requestCompanyDocsInfo }: any) => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const handelAccept = async () => {
    try {
      const { data } = await axios.post(
        `${url}/api/atab/member-company/update-request/member/documents/${id}?user_admin_id=${user.user_admin_id}`
      );
      if (data.success) {
        Toaster().fire({
          icon: "success",
          title: data.message,
        });
        navigate("/update-request/company-docs");
      }
    } catch (err: any) {
      Toaster().fire({
        icon: "error",
        title: err?.response?.data.message,
      });
    }
  };

  const handelReject = async () => {
    setLoading(true);
    if (!rejectReason) {
      setLoading(false);
      return Toaster().fire({
        icon: "error",
        title: "Please enter reject reason",
      });
    }
    try {
      const { data } = await axios.post(
        `${url}/api/atab/member-company/update-request/member/documents/${id}?confirmation_type=reject&user_admin_id=${user.user_admin_id}`,
        {
          reject_reason: rejectReason,
        }
      );
      if (data.success) {
        Toaster().fire({
          icon: "success",
          title: data.message,
        });
        navigate("/update-request/company-docs");
      }
    } catch (err: any) {
      Toaster().fire({
        icon: "error",
        title: err?.response?.data.message,
      });
    }
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Typography variant="h4" fontSize={21}>
              Requested information
            </Typography>
          }
          action={
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button size="small" variant="outlined" onClick={handelAccept}>
                Accept request
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => setOpen(true)}
              >
                Reject request
              </Button>
            </Box>
          }
        />
        <TableContainer sx={{ mb: 5 }}>
          <Table aria-label="custom pagination table">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company ffice agreement
                </TableCell>
                <TableCell align="right">
                  {" "}
                  {requestCompanyDocsInfo.company_office_agreement}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company agreement file
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_agreement_file ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${imgUrl}/${requestCompanyDocsInfo.company_agreement_file}`}
                    >
                      {requestCompanyDocsInfo.company_agreement_file}
                    </a>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company incorporation certificate
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_incorporation_certificate}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company memorandum file
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_memorandum_file ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${imgUrl}/${requestCompanyDocsInfo.company_memorandum_file}`}
                    >
                      {requestCompanyDocsInfo.company_memorandum_file}
                    </a>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Company one staff GDS certificate
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_one_staff_certificate ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${imgUrl}/${requestCompanyDocsInfo.company_one_staff_certificate}`}
                    >
                      {requestCompanyDocsInfo.company_one_staff_certificate}
                    </a>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company ownership status
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_ownership_status}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  company partnership deed file
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_partnership_deed_file ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${imgUrl}/${requestCompanyDocsInfo.company_partnership_deed_file}`}
                    >
                      {requestCompanyDocsInfo.company_partnership_deed_file}
                    </a>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company staff list file
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_staff_list_file ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${imgUrl}/${requestCompanyDocsInfo.company_staff_list_file}`}
                    >
                      {requestCompanyDocsInfo.company_staff_list_file}
                    </a>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Company office photographs
                </TableCell>
                <TableCell align="right">
                  {requestCompanyDocsInfo.company_office_photographs}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Divider />
        </TableContainer>
      </Card>

      <ModalsWrapper
        modalData={{ title: "Rejected reason" }}
        setShowModal={setOpen}
        showModal={open}
      >
        <Box
          sx={{
            mx: 4,
          }}
        >
          <TextField
            required
            rows={4}
            fullWidth
            id="reason"
            label="Rejected reason"
            placeholder="Rejected reason"
            onChange={(e) => setRejectReason(e.target.value)}
            type="text"
            multiline
            autoFocus
          />

          {loading ? (
            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                mt: 3,
                mb: 2,
                py: 1,
              }}
            >
              Loading ...
            </Button>
          ) : (
            <Button
              onClick={handelReject}
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                mt: 3,
                mb: 2,
                py: 1,
              }}
            >
              Submit
            </Button>
          )}
        </Box>

        {/* <CreateMember setAllMembers={setAllMembers} handleClose={setOpen} /> */}
      </ModalsWrapper>
    </>
  );
};

export default UpdateCompanyDocsInfo;
